import { request, requestWithMeta } from './client.js'

export interface Tuk {
  readonly id: string
  readonly code: string
  readonly name: string
}

export interface Examiner {
  readonly id: string
  readonly code: string
  readonly fullName: string
  readonly isActive: boolean
}

export interface Credential {
  readonly id: string
  readonly serial: string
  readonly validFrom: string
  readonly validUntil: string
  readonly issuedBy: string
  readonly issuedAt: string
  readonly revokedAt: string | null
  readonly revokedBy: string | null
  readonly revokedReason: string | null
  readonly lastUsedAt: string | null
  readonly useCount: number
  readonly examiner: { readonly code: string; readonly fullName: string }
  readonly tuk: { readonly code: string; readonly name: string }
}

/** Hanya ada pada respons penerbitan. Kode tidak pernah dapat diambil lagi. */
export interface IssuedCredential {
  readonly serial: string
  readonly code: string
  readonly examinerCode: string
  readonly fullName: string
}

export interface IssueResult {
  readonly diterbitkan: number
  readonly menggantikan: number
  readonly berlakuDari: string
  readonly berlakuSampai: string
  readonly kredensial: readonly IssuedCredential[]
  readonly peringatan: string
}

export async function listTuk(): Promise<readonly Tuk[]> {
  const { data } = await requestWithMeta<readonly Tuk[]>('/api/v1/tuk?limit=100')
  return data
}

export async function listExaminers(q: string): Promise<readonly Examiner[]> {
  const params = new URLSearchParams({ limit: '100' })
  if (q !== '') params.set('q', q)
  const { data } = await requestWithMeta<readonly Examiner[]>(`/api/v1/penguji?${params}`)
  return data
}

export async function listCredentials(tukId: string): Promise<readonly Credential[]> {
  const params = new URLSearchParams({ limit: '100' })
  if (tukId !== '') params.set('tukId', tukId)
  const { data } = await requestWithMeta<readonly Credential[]>(
    `/api/v1/kredensial-luring?${params}`,
  )
  return data
}

export async function issue(input: {
  tukId: string
  examinerIds: readonly string[]
  validFrom: string
  validUntil: string
}): Promise<IssueResult> {
  return request<IssueResult>('/api/v1/kredensial-luring', { method: 'POST', body: input })
}

export async function revoke(id: string, reason: string): Promise<Credential> {
  return request<Credential>(`/api/v1/kredensial-luring/${id}/cabut`, {
    method: 'POST',
    body: { reason },
  })
}
